export default () => ({
  container: {
    display: 'flex',
  },
  frame: {
    flex: 1,
    height: '100vh',
  },
});
